<template>
  <div class="user-rank">
    <div class="title-bar">
      <a-row type="flex" justify="space-between">
        <a-col :span="12">
          <a-icon type="crown" theme="twoTone" />
          <h3 class="title">用户</h3>
        </a-col>
        <a-col :span="7">
          <a-divider type="vertical" />
          <a-select @change="getUserRank()" v-model="userOrderBy">
            <a-select-option key="all" value="time">社区新人</a-select-option>
            <a-select-option key="all" value="attention">粉丝数量</a-select-option>
            <a-select-option key="week" value="workNum">作品数量</a-select-option>
            <a-select-option key="year" value="integral">金币数量</a-select-option>
          </a-select>
          <a-divider type="vertical" />
          <a-input-search
            style="width: 200px"
            placeholder="搜索用户"
            enter-button
            @search="getUserRank"
          />
        </a-col>
      </a-row>
    </div>
    <div class="user-rank-list">
      <a-empty :description="'暂无数据'" v-if="!spinning && studentRankResult.total == 0" />
      <a-spin :spinning="spinning">
        <a-carousel arrows autoplay :dots="false" v-if="studentRankResult.total > 0">
          <div slot="prevArrow" slot-scope="props" class="custom-slick-arrow">
            <a-icon type="double-left" />
          </div>
          <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow">
            <a-icon type="double-right" />
          </div>
          <div v-for="i in caroulLength" :key="i.id">
            <a-row type="flex" justify="space-around">
              <a-col
                :span="4"
                v-for="(item, index) in studentRankResult.records.slice(
                  (i - 1) * 5,
                  i * 5
                )"
                :key="index"
              >
                <a-card :shadow="true" class="card">
                  <div class="pic">
                    <img
                      @click="$toUserDetail(item.id)"
                      :src="item.avatar || item.headimgurl || '/img/avatar.png'"
                      alt
                    />
                  </div>
                  <div class="card-content">
                    <p class="title" @click="$toUserDetail(item.id)">
                      {{ item.realname || item.nickname || "神秘人" }}
                    </p>
                    <a-row type="flex" justify="center" class="num">
                      <a-col span="8">
                        <span>关注</span>
                        <p>{{ item.attention }}</p>
                      </a-col>
                      <a-col span="8">
                        <span>粉丝</span>
                        <p>{{ item.idol }}</p>
                      </a-col>
                      <a-col span="8">
                        <span>作品</span>
                        <p>{{ item.workNum }}</p>
                      </a-col>
                    </a-row>
                  </div>
                  <!-- <a-divider></a-divider>
                  <div>关注</div> -->
                </a-card>
              </a-col>
            </a-row>
          </div>
        </a-carousel>
      </a-spin>
    </div>
  </div>
</template>

<script>
import { communityCattle } from "@/api/community";
export default {
  name: "UserRankList",
  components: {},
  data() {
    return {
      spinning: true,
      userOrderBy: "time",
      userList: [],
      caroulLength: "1",
      studentRankResult: {},
    };
  },
  created() {
    this.getUserRank();
  },
  methods: {
    getUserRank() {
      communityCattle("workStarNum", 1, 20).then((res) => {
        console.log(res);
        if (res.success) {
          this.studentRankResult = res.result;
          this.caroulLength = Math.ceil(
            this.studentRankResult.records.length / 5
          );
          this.spinning = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.user-rank {
  min-height: 500px;
  .title-bar {
    text-align: left;
    margin: 50px 10px;
    i {
      font-size: 25px;
    }
    .title {
      font-size: 20px;
      font-weight: 700;
      color: white;
      margin-left: 10px;
      display: inline;
      text-shadow: 0px 0px 2px black;
    }
  }
  .user-rank-list {
    .ant-card {
      margin: 10px 0;
      box-shadow: 1px 2px 6px 0px #b6b6b6;
      .pic {
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .ant-carousel {
      .slick-next::before,
      .slick-prev::before {
        content: unset;
      }
      .slick-slide {
        text-align: center;
        height: 160px;
        line-height: 160px;
        background: #364d79;
        overflow: hidden;
      }
      .custom-slick-arrow {
        z-index: 99;
        width: 50px;
        height: 50px;
        font-size: 35px;
        color: rgb(13, 186, 255);
        // background-color: rgba(31, 45, 61, 0.11);
        opacity: 0.9;
      }
      .custom-slick-arrow:hover {
        opacity: 0.5;
      }
      .slick-slider .slick-list{
          padding: 10px 0!important;
      }
    }
  }
}
</style>